export default __webpack_public_path__ + "static/media/cmeCta.6afe4b64.png";